import angular from 'angular';

module.exports = angular.module('common.models.human', [
  require('angular-resource')
])
.factory('Human', function($resource) {
  return $resource('/api/v1/me', { id: '@id' }, {
    me: { method: 'GET' },
    update: {
      method: 'PUT',
      url: '/api/v1/humans/:id',
    },
    remoteSignOut: {
      method: 'GET',
      url: '/session/remote-sign-out',
    },
    register: {
      method: 'POST',
      url: '/register'
    },
    acceptInvite: {
      method: 'POST',
      url: '/api/v1/invites/:invitation_token/accept'
    },
    viewInvite: {
      method: 'GET',
      url: '/api/v1/invites/:invitation_token'
    }
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/models/human.js
 **/